import { getKeys } from "common/js/common-utils";
import Regs from "common/conf/Regs";
import { mapActions, mapGetters } from "vuex";
import StorageService from 'store/interfaces';
import Account from "../service/model/Account";
import SubmitText from "./model/SubmitText";
import privateKey from 'service/constant/privateKey'
import EnableStatus from 'service/constant/EnableStatus'
import LYFAcctTypes from 'service/constant/LYFAcctTypes'
import SystemDicService from 'service/SystemDicService'
import ChannelRateService from 'service/ChannelRateService'
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";

let loading;
const dialogMethods = {
    // showError(title, message, isHTML) {
    //     this.$notify.error({
    //         title: title || "发生错误",
    //         message: message || "",
    //         dangerouslyUseHTMLString: false || isHTML,
    //         duration:10000
    //     });
    // },
    showError(message) {
        this.$message.closeAll();
        this.$message({
            message: message,
            type: 'error',
        });
    },
    showSuccess(message) {
        this.$message.closeAll();
        this.$message({
            message: message,
            type: 'success',
        });
    },
    showWarming(message) {
        this.$message.closeAll();
        this.$message({
            message: message,
            type: 'warning'
        });
    },
    showLoading(message) {
        if (loading) {
            loading.setText(message ? message : '加载中……');
            return;
        }

        loading = this.$loading({
            lock: true,
            text: message ? message : '加载中……',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
        this.setLoading(true)
    },
    hideLoading() {
        if (!loading) {
            return;
        }
        this.setLoading(false);
        loading.close();
        loading = null;

    },
    showConfirm(message, customClass, isHTML) {
        return new Promise((resolve, reject) => {
            this.$confirm(message, {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                customClass: customClass,
                dangerouslyUseHTMLString: false || isHTML,
                showClose: false
            }).then(() => {
                return resolve();
            }).catch(() => {
                return reject();
            });
        });
    },
    ...mapActions({
        setLoading: StorageService.Reload.isLoading
    })
};

const validators = {
    validPhone: (rule, value, callback) => {
        if (!value) {
            callback(new Error('请输入电话号码'))
        } else if (!Regs.phone.test(value)) {
            callback(new Error('请输入正确的11位手机号码'))
        } else {
            callback()
        }
    },
    validEmail: (rule, value, callback) => {
        if (value) {
            if (!Regs.email.test(value)) {
                callback(new Error('请输入正确的邮箱地址'))
            } else {
                callback()
            }
        } else {
            callback()
        }
    },
    validPwd: (rule, value, callback) => {
        if (value) {
            if (!Regs.pwd.test(value)) {
                callback(new Error('请输入6-20位密码，数字、字母、特殊字符至少两种以上组合'))
            } else {
                callback()
            }
        } else {
            callback()
        }
    },
    validCertId: (rule, value, callback) => {
        if (!value) {
            callback(new Error('请输入身份证号码'))
        } else if (!Regs.certId.test(value)) {
            callback(new Error('请输入正确的身份证号码'))
        } else {
            callback()
        }
    },
};

const submitMethods = Object.assign({}, dialogMethods, validators, {
    doSubmit(func, data, onSuccess, text = new SubmitText({}), onFail) {
        this.showLoading(text.loadingText);
        console.log(text.loadingText)
        const startTime = new Date().getTime();
        func(data).then((data) => {
            setTimeout(() => {
                this.hideLoading();
                text.successText && this.showSuccess(text.successText);
                onSuccess && onSuccess(data);
            }, 500 - new Date().getTime() + startTime);
        }, (error) => {
            setTimeout(() => {
                this.hideLoading();
                text.failTitle = typeof text.failTitle == "function" ? text.failTitle(error) : text.failTitle;
                text.failText = typeof text.failText == "function" ? text.failText(error) : text.failText;
                this.showError(error.message);
                onFail && onFail(error.resp);
            }, 500 - new Date().getTime() + startTime);
        })
    },
    doValidAndSubmit(formName, func, data, onSuccess, text, onFail, handleCheck) {
        this.doValid(formName, handleCheck).then((a) => {
            this.doSubmit(func, data, onSuccess, text, onFail)
        });
    },
    doValid(formName, handleCheck) {
        return new Promise((resolve, reject) => {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    return resolve()
                }
                this.doValidItems(formName, getKeys(this.$refs[formName].rules), handleCheck);
            })
        });
    },
    doValidItems(formName, keys, handleCheck) {
        return new Promise((resolve, reject) => {
            const messageArr = [];
            keys = typeof keys == "string" ? keys.split(",") : keys;
            this.$refs[formName].validateField(keys, (messsage) => {
                messsage && messageArr.push(messsage);
            });

            if (messageArr.length == 0 && keys.length > 0 && !handleCheck) {
                this.hideLoading();
                return resolve()
            }
            // this.showError("校验失败", messageArr.join("</br>"), true)
            console.log("校验失败", messageArr.join(","));
            this.hideLoading();
            // reject(messageArr); 加了会报Uncaught (in promise)
        });
    }
});

const loadMethods = Object.assign({}, dialogMethods, {
    doLoad(func, data, onSuccess, failTitle, onFail, failText) {
        let timer = setTimeout(function () {
            this.showLoading();
            // dialogMethods.showLoading();
        }, 1000);
        func(data).then((data) => {
            clearTimeout(timer);
            this.hideLoading();
            onSuccess && onSuccess(data);
        }, (error) => {
            clearTimeout(timer);
            this.hideLoading();
            failTitle = typeof failTitle == "function" ? failTitle(error) : failTitle;
            failText = typeof failText == "function" ? failText(error) : failText;
            this.showError(error.message);
            onFail && onFail(error.resp);
        })
    },
    doCheck(data, onSuccess) {
        if (data.respCode == '0000') {
            onSuccess && onSuccess(data);
        } else {
            this.showError(data.respMsg);
        }
    },
    doUnicode(data) {
        // if (data) {
        //     // let reg = /^(\d{4})\d+(\d{4})$/;
        //     let reg = /(\d{4})\d*([0-9a-zA-Z]{4})/;
        //     data = data.replace(reg, "$1****$2");
        //     return data;
        // }
        return data;
    },
    getTypeNames(typeName, onSuccess) {
        const params = {
            typeName: typeName,
            userId: this.userId,
        };

        this.doLoad(SystemDicService.bytype, params, res => {
            this.doCheck(res, res => {
                const result = res.contents;
                onSuccess && onSuccess(result);
            });
        }, '信息获取失败')
    },
    // 快捷 quickly 还款repay 全部 空
    getShortNames(payType, onSuccess, chnId,tatSimpleId) {
        let type = "";

        // payType == "" ? "" : payType == 'repay' ? '2,3' : '1',  // 快捷 1 还款2，3 全部 空
        // if (payType){
        //     type = payType == 'repay' ? '2,3' : (payType == 'quickly' ?  '1' : '4')
        // }
        switch (payType) {
            case 'repay':
                type = '2,3';
                break;
            case 'quickly':
                type = '1';
                break;
            case 'hb':
                type = '6';
                break;
            case 'empty':
                type = '4';
                break;
            default:
                type = '';
        }



        const params = {
            userId: this.userId,
            chnId: chnId,
            payType: type,
            tatSimpleId:tatSimpleId,
        };

        this.doLoad(ChannelRateService.shortNames, params, res => {
            this.doCheck(res, res => {
                const result = res.contents;
                onSuccess && onSuccess(result);
            });
        }, '信息获取失败')
    },
    doCheckUnique(typeName, onSuccess) {
        const params = {
            typeName: typeName,
            userId: this.userId,
        };

        this.doLoad(SystemDicService.bytype, params, res => {
            this.doCheck(res, res => {
                const result = res.contents;
                onSuccess && onSuccess(result);
            });
        }, '信息获取失败')
    },
    toDoubleThousands(num) {
        if (!num) {
            return "0.00";
        }

        //判断是否有小数点
        var s = num.toString().indexOf(".");
        if (s == -1) {//是整数
            return (num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + ".00";
        } else {//是小数
            var arr = num.toString().split(".");
            if (arr.length > 1 && arr[1].length < 2) {//一位小数
                return (arr[0] || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + "." + arr[1] + "0";
            } else {//两位小数
                return (arr[0] || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + "." + arr[1][0] + arr[1][1];
            }
        }
    },
    toDoubleNum(num) {
        this.number_format(num, 2, '.', 'a')
    },
    number_format(number, decimals, dec_point, thousands_sep) {
        /*
           * 参数说明：
           * number：要格式化的数字
           * decimals：保留几位小数
           * dec_point：小数点符号
           * thousands_sep：千分位符号
           * */
        number = (number + '').replace(/[^0-9+-Ee.]/g, '');
        var n = !isFinite(+number) ? 0 : +number,
            prec = !isFinite(+decimals) ? 2 : Math.abs(decimals),
            sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
            dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
            s = '',
            toFixedFix = function (n, prec) {
                var k = Math.pow(10, prec);
                return '' + Math.ceil(n * k) / k;
            };

        s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
        var re = /(-?\d+)(\d{3})/;
        while (re.test(s[0])) {
            s[0] = s[0].replace(re, "$1" + sep + "$2");
        }

        if ((s[1] || '').length < prec) {
            s[1] = s[1] || '';
            s[1] += new Array(prec - s[1].length + 1).join('0');
        }
        console.log(s.join(dec))
        return s.join(dec);
    },
    getTranName(arr, type) {
        arr.forEach(item => {
            if (item.dictKey == type) {
                console.log(item.dictValue)
                return item.dictValue;
            }
        })
    },
    limitExport(total) {
        // if (total >= 1000) {
        //     this.showWarming('当前数据量过大，请进行筛选后分批导出！');
        //     return false;
        // } else {
        //     return true;
        // }
        return true;
    },
    // 表格金额格式化
    formatterTableNumber(row, column, cellValue, index) {
        return this.toYuan(cellValue);
    },
    // 表格金额格式化
    formatterTableNumberYuan(row, column, cellValue, index) {
        return this.toDoubleThousands(cellValue);
    },
    // 金额转换
    toYuan(num) {
        return this.toDoubleThousands(Number(num * 100 / 10000));
    },
    // 表格数据格式化
    formatterTableData(row, column, cellValue, index) {
        if (cellValue || typeof cellValue == 'number') {
            return cellValue
        }
        return '--'
    },
    // 表格状态格式化
    formatterEnable(row, column, cellValue, index) {
        let value = '';
        EnableStatus.forEach(item => {
            if (item.value == cellValue) {
                value = item.label
            }
        });
        return value == '' ? '--' : value;
    },
    formatterTableacctType(row, column, cellValue, index) {
        let value = "";
        LYFAcctTypes.forEach((item) => {
            if (item.dictKey == cellValue) {
                value = item.dictValue;
            }
        });
        return value == '' ? '--' : value;
    },
    formatterTableMemName(row, column, cellValue, index){
        // if (cellValue) {
        //     return cellValue.substr(0, 1) + new Array(cellValue.length).join('*');
        // }
        return cellValue
    },
    accAdd(arg1, arg2) {
        arg1 = arg1.toString(), arg2 = arg2.toString();
        var arg1Arr = arg1.split("."), arg2Arr = arg2.split("."), d1 = arg1Arr.length == 2 ? arg1Arr[1] : "", d2 = arg2Arr.length == 2 ? arg2Arr[1] : "";
        var maxLen = Math.max(d1.length, d2.length);
        var m = Math.pow(10, maxLen);
        var result = Number(((arg1 * m + arg2 * m) / m).toFixed(maxLen));
        var d = arguments[2];
        return typeof d === "number" ? Number((result).toFixed(d)) : result;
    }
});

export const submitMixin = {
    methods: submitMethods
};

export const loadMixin = {
    methods: loadMethods
};

export const dialogMixin = {
    methods: dialogMethods
};

export const validatorsMixin = {
    methods: validators
};

export const sessionMixin = {
    computed: {
        ...mapGetters(['role', 'userInfo', 'fromPage', 'device', 'loginInfo'])
    },
    methods: {
        innerPageCheck(needQuit) {
            if (null == this.role || isNaN(this.role)) {
                if (needQuit) {
                    this.setToken(null);
                    this.setUser(null);
                    this.saveAccount(new Account({
                        i: this.loginInfo.i
                    }));
                    this.$router.replace({
                        name: 'index',
                        query: {
                            registrationId: this.device.id,
                            appType: this.device.type,
                            forPos: this.device.isPos ? 1 : 0
                        }
                    });
                }
                return false;
            }
            return true;
        },
        outterPageChcek() {
            if (this.role > 0) {
                if (this.fromPage == 'main') {
                    this.$router.back();
                } else {
                    this.$router.replace({ name: 'main' });
                }
                return false;
            }
            return true;
        },
        backIndex(nextStep) {
            this.setNext(nextStep);
            if (this.fromPage == 'index') {
                this.$router.back();
            } else {
                this.$router.replace({ name: 'index' });
            }
        },
        ...mapActions({
            setFrom: StorageService.Page.setFrom,
            setNext: StorageService.Page.next,
            setToken: StorageService.User.setToken,
            setUser: StorageService.User.setInfo,
            saveAccount: StorageService.User.saveAccount,
        })
    }
};


export const mainPageMixin = {
    props: {
        isShown: {
            type: Boolean,
            default: false
        }
    },
    mounted() {
        this.$el.style.left = this.isShown ? '0' : '100%';
    },
    methods: {
        onShown() {
        }
    },
    watch: {
        isShown(newVal) {
            this.$el.style.left = newVal ? '0' : '100%';
            if (newVal) {
                this.onShown();
            }
        }
    }
};




// WEBPACK FOOTER //
// ./src/mixin/index.js